'use strict';

(function () {
  angular.module('zp').controller('VendorsWidgetController', vendorsWidgetController);

  /**@ngInject */
  function vendorsWidgetController($q, $timeout, $state, $rootScope, GooglePlacesConfig, searchBackgroundConfig, vendorsService, SearchService) {

    var vm = this;
    var vendorsJustOpened = false;

    vm.vendors = [[]];
    vm.sanitizeVendor = sanitizeVendor;
    vm.selectVendor = selectVendor;
    vm.closeVendors = closeVendors;

    ///////////////////////////////////////////

    (function () {
      loadVendors();
    })();

    function sanitizeVendor(vendor) {
      return vendor.replace(/ /g, '-').toLowerCase();
    }

    function loadVendors() {
      return vendorsService.getAll().then(function (res) {
        for (var i = 0; i < res.length; i++) {
          vm.vendors[0].push(res[i]);
        }
      });
    }

    function selectVendor(vendor) {
      //vm.searchModel.selectedCategory = vendor;
      $state.go('nav.results', { vendor: vendor });
    }

    function closeVendors() {
      if (!vendorsJustOpened) {
        vm.showOptions = false;
      }
      vendorsJustOpened = false;
    }
  }
})();